import { cn } from '@/utils/cn';

interface SkeletonProps {
  className?: string;
  width?: string | number;
  height?: string | number;
}

/**
 * Skeleton shimmer placeholder — drop-in for loading states.
 * Uses Tailwind's built-in animate-pulse (opacity oscillation) rather than a
 * gradient-sweep keyframe so that many simultaneous boxes remain performant on
 * lower-end devices.
 */
function Skeleton({ className, width, height }: SkeletonProps) {
  return (
    <div
      className={cn('animate-pulse rounded bg-dark-elevated-2', className)}
      style={{
        width: width !== undefined ? (typeof width === 'number' ? `${width}px` : width) : undefined,
        height:
          height !== undefined ? (typeof height === 'number' ? `${height}px` : height) : undefined,
      }}
      aria-hidden="true"
    />
  );
}

export default Skeleton;
